import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DashValidation } from 'dash-common';
import {
  Flex,
  Form,
  FormContext,
  Slider,
  Spinner,
  GoogleAutocomplete,
  useGoogleApiLoader,
  InputNumber,
} from 'dash-ui';
import { FormFields } from 'containers/alerts/AddAlertModal/constants/constants';

function LocationSection() {
  const { t } = useTranslation(['forms', 'forms', 'pages']);
  const isGoogleApiReady = useGoogleApiLoader();
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const [defaultViewValue, setDefaultViewValue] = useState('');
  // FIXME: re-check
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const geocoder = isGoogleApiReady ? new google.maps.Geocoder() : null;

  useEffect(() => {
    if (formState.place && geocoder) {
      geocoder.geocode(
        { location: { lat: formState.place?.lat, lng: formState.place?.lng } },
        (result) => {
          if (result?.length) {
            setDefaultViewValue(result[0].formatted_address);
          }
        }
      );
    }
  }, [geocoder, formState.place]);

  const onPlaceSelected = (place: google.maps.places.PlaceResult) => {
    stateHandlers[FormFields.Place]({
      lat: place?.geometry?.location?.lat(),
      lng: place?.geometry?.location?.lng(),
      defaultValue: place.formatted_address,
    });
  };

  return (
    <>
      <Form.Group w="100%" mt={4}>
        <Flex>
          <Form.Label>{t('forms:labels.address')}</Form.Label>
        </Flex>

        {isGoogleApiReady ? (
          <GoogleAutocomplete
            options={{
              types: ['(cities)'],
            }}
            onPlaceSelected={onPlaceSelected}
            placeholder={t('forms:labels:address') || ''}
            defaultValue={defaultViewValue}
            $errorType={formErrors[FormFields.Place]?.type}
          />
        ) : (
          <Spinner />
        )}
        <Form.Feedback $errorType={formErrors[FormFields.Place]?.type}>
          {formErrors[FormFields.Place]?.message}
        </Form.Feedback>
      </Form.Group>
      <Flex alignItems="center" mb={6}>
        <Form.Group w="100%" mt={8}>
          <Flex px={2} w="100%" alignItems="center">
            <Slider
              min={DashValidation.MinLocationRadius}
              max={DashValidation.MaxLocationRadius}
              disabled={!formState.place}
              value={formState.radius}
              defaultValue={DashValidation.DefaultLocationRadius}
              onChange={(value) => stateHandlers[FormFields.Radius](value)}
            />
          </Flex>
        </Form.Group>
        <Form.Group w="100%" mt={4} maxWidth={150}>
          <Form.Label>{t`forms:labels:radius`}</Form.Label>
          <InputNumber
            w="100%"
            value={formState.radius}
            disabled={!formState.place}
            maskOptions={{
              prefix: '',
              suffix: ` ${t('common:labels:miles')}` || '',
              includeThousandsSeparator: false,
              allowDecimal: false,
            }}
            onChangeValue={(value) => stateHandlers[FormFields.Radius](value)}
            onBlur={(e) => {
              const value = Number(
                e.target.value.replace(` ${t('common:labels:miles')}`, '')
              );
              if (value < DashValidation.MinLocationRadius) {
                stateHandlers[FormFields.Radius](
                  DashValidation.MinLocationRadius
                );
              }
              if (value > DashValidation.MaxLocationRadius) {
                stateHandlers[FormFields.Radius](
                  DashValidation.MaxLocationRadius
                );
              }
            }}
          />
        </Form.Group>
      </Flex>
    </>
  );
}

export default LocationSection;
